export const pageText: Record<string, string> = {
  'Company Portal': 'Company Portal',
  'さん、お疲れ様です': ', welcome',
  '現在の勤怠': 'Current attendance',
  '本日のシフト': "Today's shift",
  '予定なし': 'No shift scheduled',
  '希望を確認・登録': 'View or submit requests',
  '在籍スタッフ': 'Active staff',
  '未確認の希望': 'Pending requests',
  '事業ポータル': 'Business portals',
  'すべての事業へここからアクセスできます': 'Access every business from here',
  '担当事業': 'Assigned business',
  'オペレーションを開く': 'Open operations',
  '管理サイトを開く': 'Open admin site',
  '全社TOP（標準）': 'Company home (default)',
  'ログイン後の開始画面': 'Start page after sign-in',
  '全社TOPには、すべての事業への入口が表示されます。': 'The company home shows an entrance to every business.',
  'お疲れ様です、': 'Welcome, ',
  'データを読み込み中...': 'Loading data...',
  'データを読み込み中…': 'Loading data…',
  '読み込み中…': 'Loading…',
  '読み込みに失敗しました': 'Failed to load data',
  'データの取得に失敗しました': 'Failed to load data',
  '再試行': 'Try again',
  '再読込': 'Reload',
  '本日のチェックイン': "Today's check-ins",
  '本日のチェックアウト': "Today's check-outs",
  '稼働率': 'Occupancy',
  '清掃進捗': 'Housekeeping progress',
  '本日の清掃タスクはありません': 'No housekeeping tasks today',
  'クイックアクション': 'Quick actions',
  '事業管理': 'Business systems',
  '管理画面を開く': 'Open admin',
  '全事業サマリー': 'All business summary',
  'カードから管理画面へ': 'Open an admin site from a card',
  '予約集計は接続準備中': 'Reservation summary connection pending',
  '集計中…': 'Loading summary…',
  '集計を取得できません': 'Summary unavailable',
  '本日貸出': 'Pick-ups today',
  '本日返却': 'Returns today',
  '貸出中': 'On rent',
  '未読問合せ': 'Unread enquiries',
  '進行中': 'Active',
  '成約': 'Completed',
  '本日販売': 'Sold today',
  '今月販売': 'Sold this month',
  '未配信': 'Pending delivery',
  '清掃タスクを追加': 'Add housekeeping task',
  '予約を手動登録': 'Add reservation manually',
  'スタッフ全体通知': 'Notify all staff',
  '稼働率推移（直近7日間）': 'Occupancy trend (last 7 days)',
  'スタッフ勤務状況': 'Staff on duty',
  '現在出勤中のスタッフはいません': 'No staff currently clocked in',
  '清掃状況': 'Housekeeping status',
  '作業中': 'In progress',
  '未着手': 'Not started',
  '進捗': 'Progress',
  '清掃完了': 'Completed',
  '清掃中': 'Cleaning',
  '清掃待ち': 'Waiting',
  '点検待ち': 'Awaiting inspection',
  '対応必要': 'Action required',
  '担当決定': 'Assigned',
  '一時停止': 'Paused',
  '準備完了': 'Ready',
  '要確認': 'Needs review',
  '清掃不要': 'No cleaning needed',
  '今日': 'Today',
  '過去': 'Past',
  '予定': 'Upcoming',
  '前日': 'Previous day',
  '翌日': 'Next day',
  '今日に戻る': 'Back to today',
  '日付選択': 'Choose date',
  '今夜の稼働': "Tonight's occupancy",
  '部屋状態': 'Room status',
  '清掃': 'Housekeeping',
  '在室': 'Occupied',
  'チェックアウト済': 'Checked out',
  'チェックアウト済み': 'Checked out',
  'チェックイン': 'Check-in',
  'チェックアウト': 'Check-out',
  '退室済': 'Departed',
  'ノーショー': 'No-show',
  '開始注意': 'Start with care',
  '優先清掃': 'Priority cleaning',
  '宿泊': 'Stay',
  'ゲスト': 'Guest',
  '部屋': 'Room',
  '本日のスケジュール': "Today's schedule",
  '本日の予定はありません': 'No schedule today',
  '本日のチェックインはありません': 'No check-ins today',
  '本日のチェックアウトはありません': 'No check-outs today',
  '未確定': 'Unconfirmed',
  '勤怠管理': 'Attendance',
  '勤務中': 'Working',
  '休憩中': 'On break',
  '勤務外': 'Off duty',
  '出勤': 'Clock in',
  '休憩開始': 'Start break',
  '休憩終了': 'End break',
  '退勤': 'Clock out',
  '本日勤務時間': 'Hours worked today',
  '本日休憩時間': 'Break time today',
  '今月勤務時間': 'Hours worked this month',
  '最近の打刻履歴': 'Recent clock history',
  '打刻履歴はまだありません': 'No clock records yet',
  '勤務時間': 'Work hours',
  '休憩時間': 'Break time',
  'シフト数': 'Shifts',
  '休み・勤務希望': 'Time-off & availability',
  '希望休または希望する勤務時間を登録できます': 'Submit a day-off request or your preferred working hours.',
  '希望を登録': 'Submit request',
  '日付': 'Date',
  '希望内容': 'Request type',
  '終日休み': 'Full day off',
  '希望勤務時間': 'Preferred working hours',
  '開始': 'Start',
  '終了': 'End',
  '備考（任意）': 'Notes (optional)',
  '予定など、必要な場合のみ入力': 'Add details if needed',
  '登録中…': 'Submitting…',
  '今後の希望': 'Upcoming requests',
  '確認待ち': 'Pending',
  '承認': 'Approve',
  '承認済': 'Approved',
  '却下': 'Reject',
  '却下しました': 'Rejected',
  '取消': 'Withdraw',
  '取消済み': 'Withdrawn',
  '登録された希望はありません': 'No requests submitted',
  '管理者メモ：': 'Manager note: ',
  'シフト': 'Shifts',
  '公開済みシフトは全スタッフが確認できます': 'All staff can view published shifts.',
  '前週': 'Previous week',
  '今週': 'This week',
  '次週': 'Next week',
  '公開済みシフトはありません': 'No published shifts',
  'シフトを追加': 'Add shift',
  'シフトを編集': 'Edit shift',
  'スタッフ': 'Staff',
  'スタッフを選択してください': 'Select a staff member',
  '勤務先・部署': 'Workplace / department',
  '仕事内容': 'Work assignment',
  '下書き': 'Draft',
  '下書き保存': 'Save draft',
  '保存中…': 'Saving…',
  '閉じる': 'Close',
  '削除': 'Delete',
  '変更': 'Change',
  '保存': 'Save',
  '通知': 'Notifications',
  '通知機能': 'Notifications',
  'リアルタイム通知とリマインダー': 'Real-time notifications and reminders',
  '設定': 'Settings',
  'アカウント設定': 'Account settings',
  'その他の設定': 'Other settings',
  'スタッフ管理': 'Staff management',
  'スタッフを招待': 'Invite staff',
  '氏名': 'Full name',
  'メール': 'Email',
  '電話': 'Phone',
  '電話番号': 'Phone number',
  '住所': 'Address',
  '所属': 'Department',
  '所属部署': 'Department',
  '役割': 'Role',
  '役割・役職': 'Role / position',
  '権限': 'Permissions',
  '雇用形態': 'Employment type',
  '雇用条件': 'Employment terms',
  '給与': 'Pay',
  '給与形態': 'Pay type',
  '時給': 'Hourly',
  '月給': 'Monthly salary',
  '時給制': 'Hourly',
  '月給制': 'Monthly salary',
  '基本時給（円）': 'Base hourly rate (JPY)',
  '基本月給（円）': 'Base monthly salary (JPY)',
  '適用開始日': 'Effective date',
  '入社日': 'Start date',
  '有効': 'Active',
  '無効': 'Inactive',
  '有効化': 'Activate',
  '無効化': 'Deactivate',
  '書類情報': 'Documents',
  '書類状況': 'Document status',
  'パスポート': 'Passport',
  '在留カード': 'Residence card',
  'マイナンバー': 'My Number',
  '提出済': 'Submitted',
  '未提出': 'Not submitted',
  '必要': 'Required',
  '不要': 'Not required',
  '有効期限:': 'Expiry:',
  '予約管理': 'Reservations',
  '予約詳細': 'Reservation details',
  '予約を追加': 'Add reservation',
  '予約を手動追加': 'Add reservation manually',
  'ゲスト名': 'Guest name',
  'ゲスト名で検索...': 'Search by guest name...',
  '予約経路': 'Booking channel',
  '予約経路: すべて': 'Booking channel: All',
  '現場状態: すべて': 'Operational status: All',
  'すべて': 'All',
  '到着': 'Arrival',
  '出発': 'Departure',
  '到着日': 'Arrival date',
  '出発日': 'Departure date',
  '到着時刻': 'Arrival time',
  '出発時刻': 'Departure time',
  '大人': 'Adults',
  '子供': 'Children',
  '幼児': 'Infants',
  '泊': 'nights',
  '詳細': 'Details',
  '操作': 'Actions',
  '状態': 'Status',
  'ステータス': 'Status',
  '担当者': 'Assignee',
  '割り当て': 'Assign',
  '全タスク': 'All tasks',
  '写真任意': 'Photo optional',
  '写真を追加': 'Add photo',
  '写真を見る': 'View photo',
  '完了': 'Complete',
  '破損確認': 'Damage check',
  '破損なし': 'No damage',
  '破損あり': 'Damage found',
  '破損未確認': 'Not checked',
  '破損写真（必須）': 'Damage photo (required)',
  '破損内容（必須）': 'Damage details (required)',
  '破損報告を保存': 'Save damage report',
  '準備完了にする': 'Mark ready',
  '必須項目': 'Required items',
  '残り': 'remaining',
  'レポート': 'Reports',
  'レポート機能': 'Reports',
  '稼働率・清掃パフォーマンス分析': 'Occupancy and housekeeping performance',
  '処理中...': 'Processing...',
  '送信中...': 'Sending...',
  '認証中…': 'Signing in…',
  '確認中…': 'Checking…',
  'キャンセル': 'Cancel',
  '確定': 'Confirm',
  '検索条件やフィルターを変更してお試しください。': 'Try changing your search or filters.',
  '該当する予約がありません': 'No matching reservations',
  'データがありません': 'No data',
  '不明': 'Unknown',
  '手動': 'Manual',
  '新規': 'New',
  '直接予約': 'Direct',
  '飛び込み': 'Walk-in',
};

export function translatePageText(value: string): string {
  const direct = pageText[value];
  if (direct) return direct;

  const patterns: Array<[RegExp, (...parts: string[]) => string]> = [
    [/^(\d+)組到着予定$/, (count) => `${count} arrivals expected`],
    [/^(\d+)組退室予定$/, (count) => `${count} departures expected`],
    [/^(\d+)\/(\d+)室 稼働$/, (used, total) => `${used}/${total} rooms occupied`],
    [/^(\d+)\/(\d+)室 完了$/, (done, total) => `${done}/${total} rooms complete`],
    [/^(\d+)名 出勤中$/, (count) => `${count} clocked in`],
    [/^確認待ち (\d+)件$/, (count) => `${count} pending`],
    [/^(\d+)時間(\d+)分$/, (hours, minutes) => `${hours}h ${minutes}m`],
    [/^宿泊 (\d+)泊目$/, (night) => `Night ${night}`],
    [/^(\d+)泊$/, (nights) => `${nights} nights`],
    [/^必須項目 残り (\d+)$/, (count) => `${count} required items remaining`],
    [/^お疲れ様です、(.+)さん$/, (name) => `Welcome, ${name}`],
  ];

  for (const [pattern, formatter] of patterns) {
    const match = value.match(pattern);
    if (match) return formatter(...match.slice(1));
  }

  return value;
}
